export default __webpack_public_path__ + "static/media/person.72874bd6.png";